<template>
  <div id="indexPage">
    <appHeader></appHeader>
    <div class="app-container">
      <router-view />
    </div>
    <appFooter></appFooter>
    <!-- <onlineTip></onlineTip> -->
  </div>
</template>

<script>
import appHeader from '@/layouts/app-header';
import appFooter from '@/layouts/app-footer';
// import onlineTip from '@/layouts/onlineTip'
export default {
  name: 'Home',
  components: {
    appHeader,
    appFooter,
    // onlineTip
  }
};
</script>
<style lang="scss" scoped>
.app-container{
  padding: 50px 0px 30px;
}
</style>